import {FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Typography} from "@material-ui/core";
import { SocItem, SocOrganisationStability } from "../../../domain/SocItem";
import { SectionProps } from "../SectionProps";
import { Controller } from "react-hook-form";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { fieldLabels } from "../fieldLabels";
import { Error } from "../../common/Error";

export const QuestionOneSection: React.FC<SectionProps<SocItem>> = (
  sectionProps
) => {
  const { control, disabled, errors } = sectionProps;

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6">
        Current performance
        </Typography>
        <Controller
          control={control}
          name="fullAccountsUpload"
          rules={{ validate: (value) => value !== null}}
          render={(props) => (
            <FormControl component="fieldset" required disabled={disabled}>
              <FormLabel
                id="fullAccountsUpload-label"
                component="legend"
                style={{ marginBottom: "10px" }}
              >
                {fieldLabels.fullAccountsUpload}
              </FormLabel>
              <RadioGroup
                aria-labelledby="fullAccountsUpload-label"
                name="fullAccountsUpload"
                data-test="radiogroup-fullAccountsUpload"
                onChange={(e) => {
                  props.onChange(Number(e.target.value))
                }}
              >
                <FormControlLabel
                  value={SocOrganisationStability.fullAccountsUploadYes}
                  label={fieldLabels.fullAccountsUploadYes}
                  control={<Radio />}
                  data-test="fullAccountsUploadYes"
                  checked={props.value === SocOrganisationStability.fullAccountsUploadYes}
                />
                <FormControlLabel
                  value={SocOrganisationStability.fullAccountsUploadNo3months}
                  label={fieldLabels.fullAccountsUploadNo3months}
                  control={<Radio />}
                  data-test="fullAccountsUploadNo3months"
                  checked={props.value === SocOrganisationStability.fullAccountsUploadNo3months}
                />
                <FormControlLabel
                  value={SocOrganisationStability.fullAccountsUploadNoCircumstances}
                  label={fieldLabels.fullAccountsUploadNoCircumstances}
                  control={<Radio />}
                  data-test="fullAccountsUploadNoCircumstances"
                  checked={props.value === SocOrganisationStability.fullAccountsUploadNoCircumstances}
                />
              </RadioGroup>
            </FormControl>
          )}
        />
        {errors.fullAccountsUpload && (
          <>
            <br></br>
            <Error data-test="fullAccountsUpload-validation">
              You must select at one option
            </Error>
          </>
        )}
      </Grid>

      <Grid item xs={12} sm={12}>
        <Controller
          control={control}
          rules={{ maxLength: 5000 }}
          name="fullAccountsUploadInformation"
          as={
            <TextField
              label={fieldLabels.fullAccountsUploadInformation}
              readOnly={disabled}
              data-test="fullAccountsUploadInformation-field"
              rows={8}
              multiline
            />
          }
        />
        {errors.fullAccountsUploadInformation?.type === "maxLength" && (
          <Error data-test="fullAccountsUploadInformation-validation-length">
            Must be no more than 5,000 characters
          </Error>
        )}
        {errors.fullAccountsUploadInformation?.type === "required" && (
          <Error data-test="fullAccountsUploadInformation-validation-required">
            This field is required
          </Error>
        )}
      </Grid>

      <Grid item xs={12} sm={12}>
        <Typography>
          { fieldLabels.financialPerformance2023Information }
        </Typography>
        <Controller
          control={control}
          rules={{ required: true, maxLength: 10000 }}
          name="financialPerformance2023Information"
          as={
            <TextField
              readOnly={disabled}
              label="Please enter your response"
              data-test="financialPerformance2023Information-field"
              rows={8}
              multiline
              required
            />
          }
        />
        {errors.financialPerformance2023Information?.type === "maxLength" && (
          <Error data-test="financialPerformance2023Information-validation-length">
            Must be no more than 10,000 characters
          </Error>
        )}
        {errors.financialPerformance2023Information?.type === "required" && (
          <Error data-test="financialPerformance2023Information-validation-required">
            This field is required
          </Error>
        )}
      </Grid>
    </>
  );
};

